export interface CityOption {
  name: string;
  fullName: string;
}

export const searchCity = async (query: string, locale: string): Promise<CityOption[]> => {
  if (!query || query.length < 2) return [];

  const geonamesApiUrl = process.env.ENVIRONMENT === 'dev' ? 'http://api.geonames.org' : 'https://secure.geonames.org';

  try {
    const response = await fetch(
      `${geonamesApiUrl}/searchJSON?` +
        `name_startsWith=${encodeURIComponent(query)}` +
        `&maxRows=15` +
        `&orderby=population` +
        `&cities=cities500` + // ciudades con población > 500
        `&lang=${locale}` +
        `&username=nogravity`, // TODO: mover a variable de entorno
    );
    const data = await response.json();

    if (!data.geonames) return [];

    return data.geonames.map((city: any) => ({
      name: city.name,
      fullName: `${city.name}, ${city.adminName1 || city.countryName}`,
    }));
  } catch (error) {
    console.error('Error buscando ciudades:', error);
    return [];
  }
};
